// extracted by mini-css-extract-plugin
export var col = "FaqSell-module--col--jhdTM";
export var grid = "FaqSell-module--grid--1Jy5Z";
export var headline = "FaqSell-module--headline--5uvzk";
export var wrapper = "FaqSell-module--wrapper--eug3L";